define("ember-engines/engine", ["exports", "@ember/engine"], function (_exports, _engine) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = _engine.default;
});